import React from "react"
import Footer from "../navigation/footer"
import Navigation from "../navigation/navigation"
import SubNavigation from "../navigation/sub-navigation-empty"
import { defaultOffset } from "./default-layout.module.scss"
import  "../../styles/_site.scss"

export default function DefaultLayout({
  children,
  academicsMenu,
  newsMenu,
  studentMenu,
}) {
  return (
    <>
        <div id="menu" className="fixed-top">
          <Navigation
            academicsMenu={academicsMenu}
            newsMenu={newsMenu}
            studentMenu={studentMenu}
          />
        </div>
        <div className={defaultOffset}>
          <SubNavigation />
          {children}
        </div>
        <Footer />
    </>
  )
}
